import { digestArtifactContexts } from '../digestArtifactContexts';

import type { EventDefinition } from '../../types';

// `digest_action` 1-0-0 (klue-snowplow #218): the Intel Digest 2.0 actions
// that need nothing recorded beyond the act itself — a story dropped, the
// issue renamed, sent ahead of schedule or skipped. Anything that needs its
// own properties gets its own event (`digest_story_add`,
// `digest_take_action`).
//
// The issue always rides an `artifact` entity; `story_removed` attaches a
// second one for the story that left. Which door that story came through is
// the reference block's `source` in stak, joined in the warehouse rather
// than repeated here.
export const digest_action: EventDefinition = {
  getData: (action) => ({ action }),
  addContexts: digestArtifactContexts,
};
